// ============================================================
// Primitive — Puces : un texte d'agent rendu LISIBLE.
// ------------------------------------------------------------
// L'agent d'estimation écrit des phrases denses : « Bridage du lopin sur
// la table du CAK par brides et cales, mise en position sur appui plan
// et dégauchissage au comparateur, prise d'origine sur l'angle… ». Sous
// chaque opération de la gamme, ça donnait un pavé de six lignes en
// petit gris.
//
// **Un pavé ne se lit pas, donc ne se conteste pas, donc n'apprend
// rien.** Or c'est exactement ce texte-là qu'on veut faire lire : le
// deviseur ne conteste pas « 25 minutes », il conteste « dégauchissage
// au comparateur » — et c'est cette correction-là qui vaut règle.
//
// ── Une seule implémentation ──
//
// Elle vivait en double : une version dans `TempsBloc` pour les trois
// justifications, et rien du tout dans `GammeBloc`, où le besoin est le
// plus fort. Deux mises en forme du même genre de texte finissent
// toujours par diverger.
//
// ── Le découpage ──
//
// On coupe sur les séparateurs que l'agent emploie déjà — « · », « ; »,
// « — » — et sur les points suivis d'une majuscule. Le prompt lui
// demande d'écrire ainsi ; le découpage est la ceinture, le prompt est
// les bretelles. Une phrase sans aucun séparateur reste une phrase :
// on ne coupe pas au hasard pour faire joli.
//
// Au-delà de `max` puces, le reste se déplie. On ne cache rien — on
// hiérarchise.

import { useId } from 'react';

/** Le texte, découpé en idées. Jamais de coupe arbitraire. */
export function decouper(texte) {
  if (!texte) return [];
  return String(texte)
    .split(/\s*[·;]\s*|\s+—\s+|(?<=[a-zà-ÿ0-9)])\.\s+(?=[A-ZÀ-Þ])/u)
    .map((t) => t.trim().replace(/[.,;·]+$/, ''))
    .filter(Boolean);
}

export function Puces({ texte, max = 3, libelleReste = 'précision(s) de plus' }) {
  const id = useId();
  const morceaux = decouper(texte);
  if (!morceaux.length) return null;

  const tete = morceaux.slice(0, max);
  const reste = morceaux.slice(max);

  return (
    <>
      <ul className="puces">
        {tete.map((t, i) => (
          <li key={`${id}-${i}`}>{t}</li>
        ))}
      </ul>
      {reste.length ? (
        <details className="puces__reste">
          <summary>
            {reste.length} {libelleReste}
          </summary>
          <ul className="puces">
            {reste.map((t, i) => (
              <li key={`${id}-r${i}`}>{t}</li>
            ))}
          </ul>
        </details>
      ) : null}
    </>
  );
}

export default Puces;
